// src/components/Header/Header.tsx
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from 'react-i18next';
import { useLocation} from 'react-router-dom';
import {
  faBars,
  faGlobe,
  faPhone,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import styles from './Navbar.module.css';
import image from '../../assets/images/image.png'; // Adjust the path as necessary


const Navbar: React.FC = () => {
  const [nav, setNav] = useState(false);
  const [activeSection, setActiveSection] = useState('/');
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const openNav = () => {
    setNav(!nav);
  };
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (location.pathname !== '/') {
      setActiveSection('');
      return;
    }

    const sectionIds = ['/', 'services', 'contact'];
    const sections = sectionIds
      .map(id => document.getElementById(id))
      .filter(Boolean) as HTMLElement[];

    const updateSectionFromHash = () => {
      const hash = location.hash.replace('#', '');
      if (sectionIds.includes(hash)) {
        setActiveSection(hash || '/');
      } else {
        setActiveSection('/');
      }
    };

    updateSectionFromHash();

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id || '');
        }
      });
    }, {
      rootMargin: '0px 0px -50% 0px',
      threshold: 0.3,
    });

    sections.forEach(section => observer.observe(section));

    return () => observer.disconnect();
  }, [location.pathname, location.hash]);

  const getLinkClass = (section: string) => activeSection === section ? styles.active : '';

  return (

    <header className={styles.navbarSection}>

      <div className={styles.navbarTitle}>
        <a href="/" >
          <div className={styles.navbarLogo}>
            <img
              src={image}
              alt="Carrotage Pro"
              className={styles.logoImage}
              // style={{
              //   width: '90px',
              //   height: '80px'
              // }}
            />
            <span className={styles.navbarSign}> Carottage Pro</span>

          </div>
        </a>
      </div>
      <div className={styles.ftSocialLinks}>

        <li>
          <a
            href="https://www.facebook.com/profile.php?id=61587083473957"
            title="FaceBook"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="1em"
              viewBox="0 0 320 512"
            >
              <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
            </svg>
          </a>
        </li>
        <li>
          <a
            href="https://www.instagram.com/ste.carottagepro/"
            title="Instagram"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="1em"
              viewBox="0 0 448 512"
            >
              <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
            </svg>
          </a>
        </li>
        <li>
          <a
            href="https://www.facebook.com/profile.php?id=61587083473957"
            title="YouTube"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="1em"
              viewBox="0 0 576 512"
            >
              <path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6C14.7 168.2 14.7 256 14.7 256s0 87.8 11.6 131.9c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.1 48.3-47.8C561.3 343.8 561.3 256 561.3 256s0-87.8-11.6-131.9zM232 334.4V177.6L361.6 256 232 334.4z" />
            </svg>
          </a>
        </li>


      </div>
      <div className={styles.container}>
        {/* Desktop */}
        <nav className={styles.navigation}>
          <ul >
            <li>
              <a href="/" className={getLinkClass('/')}>
                {t('home')}
              </a>
            </li>
            <li>
              <a href="#services" className={getLinkClass('services')}>
                {t('services')}
              </a>
            </li>

            <li>
              <a href="#contact" className={getLinkClass('contact')}>
                {t('contact')}
              </a>
            </li>

          </ul>

        </nav>
        <div className={styles.authButtons}>
          <a
            href="tel:+21693698084"
            className={`${styles.btn} ${styles.btnOutline}`
            }
          >
            <FontAwesomeIcon
              icon={faPhone}
              style={{ color: "white" }}
            />
            <span className={styles.phoneText}> 93 698 084</span>
          </a>
        </div>
        <div className={styles.rightIcons}>
        <div style={{ position: "relative", display: "inline-block" }}>
          {/* Globe icon */}
          <FontAwesomeIcon
            icon={faGlobe}
            className={styles.langIcon}
            onClick={() => setOpen(!open)}
          />

          {/* FULL SCREEN OVERLAY */}
          {open && (
            <>
              {/* invisible background layer */}
              <div
                onClick={() => setOpen(false)}
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: "transparent",
                  zIndex: 999,
                }}
              />

              {/* dropdown */}
              <div
                style={{
                  position: "absolute",
                  top: "30px",
                  right: 0,
                  background: "white",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  padding: "8px",
                  zIndex: 1000,
                }}
              >
                <a
                  href="/"
                  style={{ textDecoration: "none", color: " #24445C" }}
                  onClick={(e) => {
                    e.preventDefault();
                    i18n.changeLanguage("fr");
                    setOpen(false);
                  }}
                >
                  Français
                </a>

                <div
                  style={{
                    height: "1px",
                    background: "#e5e5e5",
                    margin: "6px 0",
                  }}
                />

                <a
                  href="/"
                  style={{ textDecoration: "none", color: " #24445C" }}
                  onClick={(e) => {
                    e.preventDefault();
                    i18n.changeLanguage("ar");
                    setOpen(false);
                  }}
                >
                  العربية
                </a>
              </div>
            </>
          )}
        </div>
      </div>



      {/* Mobile */}
      <div className={`${styles.mobileNavbar} ${nav ? styles.openNav : ""}`}>
        <div onClick={openNav} className={styles.mobileNavbarClose}>
          <FontAwesomeIcon icon={faXmark} className={styles.hambIcon} />
        </div>

        <ul className={styles.mobileNavbarLinks}>
          <li>
            <a onClick={openNav} href="/" className={getLinkClass('/')}>
              {t('home')}
            </a>
          </li>
          <li>
            <a onClick={openNav} href="#services" className={getLinkClass('services')}>
              {t('services')}
            </a>
          </li>
          <li>
            <a onClick={openNav} href="#contact" className={getLinkClass('contact')}>
              {t('contact')}
            </a>
          </li>
          <li>
            <div className={styles.ftSocialLinks2}>

              <li>
                <a
                  href="https://www.facebook.com/profile.php?id=61587083473957"
                  title="FaceBook"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="1em"
                    viewBox="0 0 320 512"
                  >
                    <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/ste.carottagepro/"
                  title="Instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="1em"
                    viewBox="0 0 448 512"
                  >
                    <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/profile.php?id=61587083473957"
                  title="YouTube"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="1em"
                    viewBox="0 0 576 512"
                  >
                    <path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6C14.7 168.2 14.7 256 14.7 256s0 87.8 11.6 131.9c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.1 48.3-47.8C561.3 343.8 561.3 256 561.3 256s0-87.8-11.6-131.9zM232 334.4V177.6L361.6 256 232 334.4z" />
                  </svg>
                </a>
              </li>


            </div>

          </li>


        </ul>
      </div>

      {/* Hamburger Icon */}
      <div className={styles.mobileNav}>
        <FontAwesomeIcon
          icon={faBars}
          onClick={openNav}
          className={styles.hambIcon}
        />
      </div>
      </div>
    </header>
  );
}

export default Navbar;